import { render, staticRenderFns } from "./transAcctTauditFail.vue?vue&type=template&id=7350e0ac&scoped=true&"
import script from "./transAcctTauditFail.vue?vue&type=script&lang=js&"
export * from "./transAcctTauditFail.vue?vue&type=script&lang=js&"
import style0 from "./transAcctTauditFail.vue?vue&type=style&index=0&id=7350e0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350e0ac",
  null
  
)

export default component.exports